import {useEffect, useState} from 'react'

import {useLocation, useNavigate} from 'react-router-dom'
import {verifyInvite} from '../core/_requests'
import {useAuth} from '../core/Auth'
import {toast} from 'react-toastify'
import {useIntl} from 'react-intl'
import {BasicButton} from '../../widgets/components/UI/BasicButton'
import redCross from '../../../../media/images/ic-close.svg'

const VerifyInvite = () => {
  const navigate = useNavigate()
  const [errors, setError] = useState<any>(undefined)
  const {userToken, logout} = useAuth()
  const {pathname} = useLocation()
  const {formatMessage} = useIntl()
  const inviteToken = pathname.split('/')[3]

  useEffect(() => {
    if (userToken) {
      logout()
      document.location.reload()
    }
  }, [userToken]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const getVerifyToken = async () => {
      try {
        const {
          data: {success, data, errors},
        } = await verifyInvite(inviteToken)

        if (success) {
          if (data.userExists) {
            navigate('/auth/login', {state: data})
            setTimeout(() => {
              toast.success(
                formatMessage({id: 'Invite accepted. Please log into the correct account.'})
              )
            }, 500)
          } else {
            navigate('/auth/registration', {state: {...data, inviteToken}})
            setTimeout(() => {
              toast.success(formatMessage({id: 'Please sign up below to accept the invite.'}))
            }, 500)
          }
        } else {
          setError(errors)
          console.log(errors)
        }
      } catch (err) {
        console.log(err)
      }
    }
    if (!userToken) {
      // Call verify invite API only if user is not logged in
      getVerifyToken()
    }
  }, [inviteToken, userToken]) // eslint-disable-line react-hooks/exhaustive-deps

  const Host = window.location.host
  const protocol = window.location.protocol
  const registrationUrl = Host.includes('localhost')
    ? `/auth/registration/?lp=generic&utm_source=recordskeeper.ai&utm_medium=web-app&utm_campaign=file-requests`
    : `${protocol}//${Host}/auth/registration/?lp=generic&utm_source=recordskeeper.ai&utm_medium=web-app&utm_campaign=file-requests`
  return (
    <>
      <div
        className='d-flex flex-column justify-content-center align-items-center'
        style={{height: '100vh'}}
      >
        {errors?.map((error: string) => (
          <>
            <img src={redCross} alt='banner' height={80} width={80} className='w-100 mb-8' />
            <p className='text-center mb-4'>
              {formatMessage({
                id: `${error}`,
              })}
            </p>
          </>
        ))}

        <div className='d-flex justify-content-center align-items-center'>
          <BasicButton
            height='44px'
            border='1px solid #4776E6'
            color='#4776E6'
            textColor='white'
            padding='12px 24px'
            onClick={() => {
              window.open(registrationUrl, '_blank')
            }}
            buttonText={'Try Recordskeeper'}
            minWidth={56}
          />
        </div>
      </div>
    </>
  )
}

export {VerifyInvite}
